import React from 'react';

interface IProps {
  size?: string;
  height?: string;
}

const HeartIcon: React.FC<IProps> = ({ size = '30', height = '28' }) => (
  <svg
    width={size}
    height={height}
    viewBox="0 0 30 28"
    className={`w-[${size}px] h-[${height}px]`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9308 3.72228C16.1717 2.32627 19.76 -0.0934865 24.1858 1.39559C28.6117 2.88467 29.8216 7.73797 29.8733 9.97848C29.9414 13.1462 27.1254 20.912 15.3569 27.0289C15.0908 27.1672 14.7719 27.1789 14.5002 27.0518C9.6514 24.7838 0.625113 18.5288 0.143407 9.97848C-0.0984324 5.68582 2.71957 2.31093 5.98593 1.22259C7.67496 0.65981 11.8286 0.371858 14.9308 3.72228ZM22.583 3.05013C18.6814 2.35031 16.0793 4.85412 15.0988 6.43119C15.0188 6.55985 14.828 6.5663 14.741 6.44232C11.9464 2.46265 8.20833 2.51092 6.65809 3.05013C1.22915 5.27341 1.64278 10.9092 4.02117 15.2523C5.82551 18.5472 11.4611 22.8774 14.4641 24.9183C14.7539 25.1152 15.1233 25.1425 15.4254 24.9652C17.8313 23.5527 23.2054 19.0101 25.892 15.2523C28.7828 11.209 27.7716 3.9808 22.583 3.05013Z"
      fill="#F4F2F5"
    />
    <path
      d="M14.741 6.44232C14.828 6.5663 15.0188 6.55985 15.0988 6.43119C16.0793 4.85412 18.6814 2.35031 22.583 3.05013C27.7716 3.9808 28.7828 11.209 25.892 15.2523C23.2054 19.0101 17.8313 23.5527 15.4254 24.9652C15.1233 25.1425 14.7539 25.1152 14.4641 24.9183C11.4611 22.8774 5.82551 18.5472 4.02117 15.2523C1.64278 10.9092 1.22915 5.27341 6.65809 3.05013C8.20833 2.51092 11.9464 2.46265 14.741 6.44232Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9308 3.72228C16.1717 2.32627 19.76 -0.0934865 24.1858 1.39559C28.6117 2.88467 29.8216 7.73797 29.8733 9.97848C29.9414 13.1462 27.1254 20.912 15.3569 27.0289C15.0908 27.1672 14.7719 27.1789 14.5002 27.0518C9.6514 24.7838 0.625113 18.5288 0.143407 9.97848C-0.0984324 5.68582 2.71957 2.31093 5.98593 1.22259C7.67496 0.65981 11.8286 0.371858 14.9308 3.72228ZM22.583 3.05013C18.6814 2.35031 16.0793 4.85412 15.0988 6.43119C15.0188 6.55985 14.828 6.5663 14.741 6.44232C11.9464 2.46265 8.20833 2.51092 6.65809 3.05013C1.22915 5.27341 1.64278 10.9092 4.02117 15.2523C5.82551 18.5472 11.4611 22.8774 14.4641 24.9183C14.7539 25.1152 15.1233 25.1425 15.4254 24.9652C17.8313 23.5527 23.2054 19.0101 25.892 15.2523C28.7828 11.209 27.7716 3.9808 22.583 3.05013Z"
      stroke="white"
      strokeWidth="0.2"
    />
    <path
      d="M14.741 6.44232C14.828 6.5663 15.0188 6.55985 15.0988 6.43119C16.0793 4.85412 18.6814 2.35031 22.583 3.05013C27.7716 3.9808 28.7828 11.209 25.892 15.2523C23.2054 19.0101 17.8313 23.5527 15.4254 24.9652C15.1233 25.1425 14.7539 25.1152 14.4641 24.9183C11.4611 22.8774 5.82551 18.5472 4.02117 15.2523C1.64278 10.9092 1.22915 5.27341 6.65809 3.05013C8.20833 2.51092 11.9464 2.46265 14.741 6.44232Z"
      stroke="white"
      strokeWidth="0.2"
    />
    <g filter="url(#filter0_i_4139_231825)">
      <path
        d="M14.8208 6.45373C14.8572 6.51745 14.9478 6.52681 14.9952 6.47082C15.5974 5.75921 18.8642 2.16074 22.7935 2.86326C28.2383 3.83677 29.5214 11.6248 26.2659 15.627C23.2309 19.3581 17.7438 24.3105 15.256 25.7977C14.9561 25.9769 14.5873 25.95 14.298 25.7542C11.1529 23.6262 5.2134 19.0823 3.3151 15.627C0.819261 11.084 0.385203 5.18885 6.08222 2.86326C11.6369 1.41264 14.3496 5.62793 14.8208 6.45373Z"
        fill="url(#paint0_radial_4139_231825)"
      />
    </g>
    <path
      d="M14.8208 6.45373C14.8572 6.51745 14.9478 6.52681 14.9952 6.47082C15.5974 5.75921 18.8642 2.16074 22.7935 2.86326C28.2383 3.83677 29.5214 11.6248 26.2659 15.627C23.2309 19.3581 17.7438 24.3105 15.256 25.7977C14.9561 25.9769 14.5873 25.95 14.298 25.7542C11.1529 23.6262 5.2134 19.0823 3.3151 15.627C0.819261 11.084 0.385203 5.18885 6.08222 2.86326C11.6369 1.41264 14.3496 5.62793 14.8208 6.45373Z"
      stroke="white"
      strokeWidth="0.2"
    />
    <defs>
      <filter
        id="filter0_i_4139_231825"
        x="1.46094"
        y="2.46191"
        width="26.6758"
        height="25.0562"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.5" />
        <feGaussianBlur stdDeviation="0.75" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4139_231825" />
      </filter>
      <radialGradient
        id="paint0_radial_4139_231825"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.7988 13.3589) rotate(90) scale(43.9422 49.556)"
      >
        <stop stopColor="#EDE5EA" />
        <stop offset="1" stopColor="#C0B7CA" />
      </radialGradient>
    </defs>
  </svg>
);

export default HeartIcon;
